import { REDUX_STORE } from '@funnels/constants';
import {
  ClearConveyancingDataAction,
  ClearConveyancingErrorAction,
  CreateConveyancingAction,
  CreateConveyancingIntentAction,
  CreateConveyancingIntentFailAction,
  CreateConveyancingIntentSuccessAction,
  FetchConveyancingAction,
  FetchConveyancingFailAction,
  FetchConveyancingIntentAction,
  FetchConveyancingIntentFailAction,
  FetchConveyancingIntentSuccessAction,
  FetchConveyancingSuccessAction,
  ServerConveyancingCreateIntentRequest,
  ServerConveyancingFetchRequest,
  ServerConveyancingFetchResponse,
  StoreConveyancing,
} from '@funnels/types';

export function fetchConveyancing(payload: ServerConveyancingFetchRequest): FetchConveyancingAction {
  return { type: REDUX_STORE.CONVEYANCING.ACTION_TYPES.FETCH_CONVEYANCING, payload };
}

export function fetchConveyancingSuccess(enquiries: StoreConveyancing): FetchConveyancingSuccessAction {
  return { type: REDUX_STORE.CONVEYANCING.ACTION_TYPES.FETCH_CONVEYANCING_SUCCESS, enquiries };
}

export function fetchConveyancingFail(): FetchConveyancingFailAction {
  return { type: REDUX_STORE.CONVEYANCING.ACTION_TYPES.FETCH_CONVEYANCING_FAIL };
}

export function fetchConveyancingIntent(payload: ServerConveyancingFetchRequest): FetchConveyancingIntentAction {
  return { type: REDUX_STORE.CONVEYANCING.ACTION_TYPES.FETCH_CONVEYANCING_INTENT, payload };
}

export function fetchConveyancingIntentSuccess(
  enquiries: ServerConveyancingFetchResponse
): FetchConveyancingIntentSuccessAction {
  return { type: REDUX_STORE.CONVEYANCING.ACTION_TYPES.FETCH_CONVEYANCING_INTENT_SUCCESS, enquiries };
}

export function fetchConveyancingIntentFail(): FetchConveyancingIntentFailAction {
  return { type: REDUX_STORE.CONVEYANCING.ACTION_TYPES.FETCH_CONVEYANCING_INTENT_FAIL };
}

export function createConveyancingPropertyId(assetId: string): CreateConveyancingAction {
  return { type: REDUX_STORE.CONVEYANCING.ACTION_TYPES.CREATE_CONVEYANCING_PROPERTY_ID, assetId };
}

export function createConveyancingIntent(
  payload: ServerConveyancingCreateIntentRequest
): CreateConveyancingIntentAction {
  return {
    type: REDUX_STORE.CONVEYANCING.ACTION_TYPES.CREATE_CONVEYANCING_INTENT,
    payload,
  };
}

export function createConveyancingIntentSuccess(enquiryId: string): CreateConveyancingIntentSuccessAction {
  return { type: REDUX_STORE.CONVEYANCING.ACTION_TYPES.CREATE_CONVEYANCING_INTENT_SUCCESS, enquiryId };
}

export function createConveyancingIntentFail(): CreateConveyancingIntentFailAction {
  return { type: REDUX_STORE.CONVEYANCING.ACTION_TYPES.CREATE_CONVEYANCING_INTENT_FAIL };
}

export function clearConveyancingError(): ClearConveyancingErrorAction {
  return { type: REDUX_STORE.CONVEYANCING.ACTION_TYPES.CLEAR_CONVEYANCING_ERROR };
}

export function resetConveyancing(): ClearConveyancingDataAction {
  return { type: REDUX_STORE.CONVEYANCING.ACTION_TYPES.CLEAR_CONVEYANCING_DATA };
}
